import React from 'react';
import { HiSparkles } from 'react-icons/hi';
import { FaUniversity, FaCoins } from 'react-icons/fa';
import CleanButton from '../CleanButton/CleanButton'; // Your button component
import './TopUpCard.scss';

const TopUpCard = ({ 
  planName, 
  creditBalance, 
  price, 
  priceWithVat,
  isPopular = false 
}) => {
  return (
    <div className={`topup-card ${isPopular ? 'popular' : ''}`}>
      <div className="card h-100">
        <div className="card-body d-flex flex-column">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <HiSparkles className="plan-icon me-2" />
              <h5 className="card-title mb-0">{planName}</h5>
            </div>
            {/* Gold coin icon */}
            <div className="gold-coin">
              <FaCoins />
            </div>
          </div>

          {/* Credit Balance */}
          <div className="credit-section flex-grow-1">
            <div className="credit-item d-flex align-items-center mb-4">
              <div className="credit-icon me-3">
                <FaUniversity className="icon-credits" />
              </div>
              <div className="credit-content">
                <div className="credit-label">Credit Balance</div>
                <div className="credit-value">{creditBalance.toLocaleString()}</div>
              </div>
            </div>
          </div>

          {/* Price Button */}
          <div className="mt-auto">
            <div className="price-button-container">
              <CleanButton
                variant="primary"
                size="lg"
                className="w-100 topup-button-custom"
                disabled={true}
              >
                <span className="price-text">{price} €</span>
              </CleanButton>
            </div>
            <div className="price-note text-center mt-2">
              {priceWithVat} € with VAT included
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopUpCard;